import classes from './HambrMenuSvgToggle.module.scss';

export default function HambrMenuSvgToggle({ siderToggled, handleToggle }) {
  return (
    <div
      className={`${classes.svgContainer} ${
        siderToggled ? classes.toggled : ''
      }`}
      onClick={handleToggle}
    >
      <svg
        className={classes.svgDefault}
        width="62"
        height="40"
        viewBox="0 0 62 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M60 2L2 2"
          stroke="#333333"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M48.6521 20L1.99992 20"
          stroke="#333333"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M34.7827 38H2.00011"
          stroke="#333333"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>

      <svg
        className={classes.svgToggled}
        width="62"
        height="40"
        viewBox="0 0 62 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M60 2L2.00003 2"
          stroke="#F5F5F5"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M60 20L13.3478 20"
          stroke="#F5F5F5"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M60 38H27.2174"
          stroke="#F5F5F5"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
